const intervals = new WeakMap();

function pad(value) {
  return String(value).padStart(2, '0');
}

function getNextAnnualTarget(month, day) {
  const now = new Date();
  let year = now.getFullYear();
  let target = new Date(year, month - 1, day, 0, 0, 0, 0);

  if (target.getTime() <= now.getTime()) {
    target = new Date(year + 1, month - 1, day, 0, 0, 0, 0);
  }

  return target;
}

function updateCountdown(root) {
  const month = Number(root.dataset.month);
  const day = Number(root.dataset.day);

  if (!month || !day) return;

  const target = getNextAnnualTarget(month, day);
  const diff = Math.max(0, target.getTime() - Date.now());

  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  const minutes = Math.floor((diff % 3600000) / 60000);
  const seconds = Math.floor((diff % 60000) / 1000);

  const daysEl = root.querySelector('[data-countdown-days]');
  const hoursEl = root.querySelector('[data-countdown-hours]');
  const minutesEl = root.querySelector('[data-countdown-minutes]');
  const secondsEl = root.querySelector('[data-countdown-seconds]');

  if (daysEl) daysEl.textContent = days;
  if (hoursEl) hoursEl.textContent = pad(hours);
  if (minutesEl) minutesEl.textContent = pad(minutes);
  if (secondsEl) secondsEl.textContent = pad(seconds);
}

function initCountdown(root) {
  if (intervals.has(root)) return;

  updateCountdown(root);
  const interval = window.setInterval(() => updateCountdown(root), 1000);
  intervals.set(root, interval);
}

function initAllCountdowns(scope = document) {
  scope.querySelectorAll('[data-lre-countdown]').forEach(initCountdown);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initAllCountdowns());
} else {
  initAllCountdowns();
}

document.addEventListener('shopify:section:load', (event) => {
  initAllCountdowns(event.target);
});
